import React from "react";
import { Main } from "../../components/utilities";
import ClientFactFind from "../../features/clientfactfind";
import ClientFactFindPageSubHeader from "../../features/clientfactfind/components/ClientFactFindPageSubHeader";

const ClientFactFindPage = () => {

    return <React.Fragment>
        <ClientFactFindPageSubHeader />
        <Main className="p-3">
            <ClientFactFind />
        </Main>
    </React.Fragment>;
}

export default ClientFactFindPage;